module.exports = __webpack_public_path__ + "img/advant1.435aa4ec.png";